import { render, staticRenderFns } from "./usePower.vue?vue&type=template&id=9a4f7c8e&scoped=true&"
import script from "./usePower.vue?vue&type=script&lang=js&"
export * from "./usePower.vue?vue&type=script&lang=js&"
import style0 from "./usePower.vue?vue&type=style&index=0&id=9a4f7c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4f7c8e",
  null
  
)

export default component.exports